import storeModule from '../store-module'
import { defineStore } from 'pinia'
import axios from 'axios'

// TODO: Remover funções das actions para evitar dependencia da store.
export default defineStore('legal-documents',
  storeModule.createStoreModule('legal-documents', {
    actions: {
      async fetch ({ params, saleId }) {
        const { data: { results, fields, metadata } } = await axios.get(`sales/${saleId}/legal-documents`, { params })

        return { results, fields, metadata }
      },

      async send ({ payload, saleId }) {
        const { data: { results, fields, metadata } } = await axios.post(`sales/${saleId}/legal-documents`, payload)

        return { results, fields, metadata }
      },

      async verifySignatures (documentUuid) {
        const { data: { results } } = await axios.get(`legal-documents/${documentUuid}/verify-signatures`)

        return { results }
      },

      async download (documentUuid) {
        const { data: { result } } = await axios.get(`legal-documents/${documentUuid}/download`)

        return { result }
      },

      async cancel ({ documentUuid, reason }) {
        const { data: { results } } = await axios.put(`legal-documents/${documentUuid}/cancel`, { reason })

        return { results }
      },
      async fetchHistory (payload) {
        const { url, ...params } = payload

        const { data: { results, metadata } } = await axios.get(url, { params })

        return { results, metadata }
      }
    }
  })
)
